import React from "react";

const TableKomparasiSekolah = ({ listResume }) => {
    require("./Ensa.css");
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <table className="table table-custom" id="rekap"> 
                <thead>
                    <tr>
                        <th className="th-title v-align-center" align="left" rowSpan="2" scope="col" style={{width: '25%'}}>
                            Sekolah
                        </th>
                        <th className="th-title v-align-center" rowSpan="2" scope="col" style={{textAlign: 'center'}}>
                            Beriman
                        </th>
                        <th className="th-title v-align-center" rowSpan="2" scope="col" style={{textAlign: 'center'}}>
                            Gotong Royong
                        </th>
                        <th className="th-title v-align-center" rowSpan="2" scope="col" style={{textAlign: 'center'}}>
                            Berkebhinekaan
                        </th>
                        <th className="th-title v-align-center" rowSpan="2" scope="col" style={{textAlign: 'center'}}>
                            Mandiri
                        </th>
                        <th className="th-title v-align-center" rowSpan="2" scope="col" style={{textAlign: 'center'}}>
                            Kritis
                        </th>
                        <th className="th-title v-align-center" rowSpan="2" scope="col" style={{textAlign: 'center'}}>
                            Kreatif
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {listResume.map((item, i) =>
                        <tr key={i}>
                            <td align="left">{item.sekolah}</td>
                            <td align="center">{item.beriman}</td>
                            <td align="center">{item.goyong}</td>
                            <td align="center">{item.berkebhinekaan}</td>
                            <td align="center">{item.mandiri}</td>
                            <td align="center">{item.kritis}</td>
                            <td align="center">{item.kreatif}</td>
                        </tr>
                    )}

                </tbody>
            </table>
        </div>

    );
};

export default TableKomparasiSekolah;
